/* a (possible) universal helper file for all things product table */

/* TODO: port table mapping -> data dependency logic here? */
/* TODO: port table mapping -> config logic here? */

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

// add type -> text mappings here
const defaultCtaMap = {
  studentLoans: 'Apply now',
  savings: 'Start saving',
};

/*
  potential hook for custom mapping
*/
const getDefaultCtaFromDependency =
  (tableDependency) =>
  (customCtaMap = defaultCtaMap) =>
    get(customCtaMap, tableDependency, 'Learn more');

export default getDefaultCtaFromDependency;
